module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column",
    attrs: {
      "id": "lista-de-assinantes"
    }
  }, [_c('div', {
    staticClass: "container container_com-fundo container_com-margem"
  }, [_c('loading', {
    attrs: {
      "ativo": _vm.loading.visivel
    }
  }), _vm._v(" "), (!_vm.loading.visivel && _vm.assinantes.length === 0) ? _c('h4', {
    staticClass: "titulo titulo_pequeno"
  }, [_vm._v("\n      Nenhum assinante encontrado\n    ")]) : _vm._e(), _vm._v(" "), (_vm.assinantes.length > 0) ? _c('table', {
    staticClass: "tabela tabela_listrada tabela_com-largura-total"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', _vm._l((_vm.assinantes), function(assinante) {
    return _c('tr', {
      key: assinante.Id
    }, [_c('td', [_vm._v(_vm._s(assinante.Nome))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(assinante.Cargo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(assinante.Email))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(assinante.PossuiAssinaturaDigital ? 'Sim' : 'Não'))]), _vm._v(" "), _c('td', [_c('input', {
      staticClass: "formulario__checkbox-marcador",
      attrs: {
        "type": "checkbox",
        "disabled": assinante.EhAtual
      },
      domProps: {
        "checked": assinante.EhAtual
      },
      on: {
        "change": function($event) {
          return _vm.abrirModalDeConfirmacao(assinante)
        }
      }
    })])])
  }), 0)]) : _vm._e()], 1), _vm._v(" "), (_vm.modalVisivel) ? _c('modal', {
    on: {
      "close": _vm.fecharModal
    }
  }, [_c('div', [_c('h3', {
    staticClass: "titulo titulo_medio"
  }, [_vm._v("Confirmar assinante atual")]), _vm._v(" "), _c('p', {
    staticClass: "mensagem-confirmacao"
  }, [_c('strong', [_vm._v(_vm._s(_vm.assinanteSelecionado && _vm.assinanteSelecionado.Nome))]), _vm._v("\n        passará a ser o assinante atual. Deseja prosseguir?\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "grade__coluna u-texto-alinhado-a-direita"
  }, [_c('button', {
    staticClass: "botao botao_cinza",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.fecharModal
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('button', {
    staticClass: "botao botao_cor-terciaria",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.confirmarDefinicaoDeAtual
    }
  }, [_vm._v("Confirmar")])])])]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Nome")]), _vm._v(" "), _c('th', [_vm._v("Cargo")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th', [_vm._v("Assinatura Digital")]), _vm._v(" "), _c('th', [_vm._v("Atual")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-91cc0756"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/assinantes/ListaDeAssinantes.vue
// module id = 1134
// module chunks = 1